import spacing from "styles/spacing";

export const DefaultPricingUsageReport = {
  TitleStyle: { marginTop: spacing.horizontalMargin20 }
};
